module.exports = __webpack_public_path__ + "img/validate.4bfd7ae1.png";